/* eslint-disable max-len */
import { projectDomainName } from 'shared/constants'
import { languagesType } from 'shared/locale'
import { BonusName } from 'shared/models/Promotion'

const bonusCardInfo = {
  'es-ES': {
    firstFreeSpins: (freeSpinCount: string) => `
      <span>
     ¡En ${projectDomainName}, los <span style="color: #f2b62e">${freeSpinCount} giros gratis</span> sin depósito están disponibles para todos los jugadores de forma permanente! Este bono de giros gratis se aplica a cada depósito del jugador. Un giro gratis es un giro en las tragamonedas en el que no se deduce dinero del saldo del jugador.
      </span>
    `,
    everyFreeSpins: (freeSpinCount: string) => `
      <span>
     ¡En ${projectDomainName}, los <span style="color: #f2b62e">${freeSpinCount} giros gratis</span> sin depósito están disponibles para todos los jugadores de forma permanente! Este bono de giros gratis se aplica a cada depósito del jugador. Un giro gratis es un giro en las tragamonedas en el que no se deduce dinero del saldo del jugador.
      </span>
    `,
    firstDeposit: (depositBonus: string) => `
     <span>
  Aquí en ${projectDomainName}, <span style="color: #f2b62e">un bono de primer depósito de ${depositBonus}%</span>
  está disponible permanentemente para todos los nuevos jugadores.
  Este bono se aplica únicamente al primer depósito del jugador y equivale a <span style="color: #f2b62e">${depositBonus}%</span> del monto depositado.
  El dinero del bono son recompensas equivalentes a dinero real que el usuario recibe del casino de forma gratuita. Al retirar fondos, el bono no utilizado se cancela.
</span>
    `,
    everyDeposit: (depositBonus: string) => `
     <span>
  Aquí en ${projectDomainName} <span style="color: #f2b62e">un Bono de Depósito de ${depositBonus}%</span>
  está disponible permanentemente para todos los jugadores!
  Este bono se aplica a cada depósito del jugador y equivale a <span style="color: #f2b62e">${depositBonus}%</span> del monto depositado.
  El dinero del bono son recompensas equivalentes a dinero real que el usuario recibe del casino de forma gratuita.
  Al retirar fondos, el bono no utilizado se cancela!
</span>
    `,
    register: (freeSpinCount: string, wagerCoefficient: string) => `
  <span>
    Este bono te permite disfrutar de los juegos de tragamonedas disponibles en "juegos abiertos"
     en tu área de promociones, donde cada giro se deducirá de los <span style="color: #f2b62e">${freeSpinCount} GIROS GRATIS</span>!
      Cualquier saldo ganado durante estas jugadas se puede convertir en saldo real, listo para ser utilizado en juegos o retirado.
       Sin embargo, es importante observar la regla de reinversión: la cantidad ganada en los Giros Gratis se multiplica por <span style="color: #f2b62e">${wagerCoefficient}</span>, por lo que tu objetivo debe alcanzarse en un plazo de 7 días.
        Para lograr este logro, simplemente haz un depósito y continúa jugando. ¡La diversión está garantizada!
</span>
`,
  },
  'pt-BR': {
    firstFreeSpins: (freeSpinCount: string) => `
      <span>
        Aqui no ${projectDomainName} <span style="color: #f2b62e">${freeSpinCount} Giros Grátis</span>! no Primeiro Depósito estão disponíveis para todos os novos jogadores permanentemente!
           Este bônus de Giros Grátis se aplica apenas ao primeiro depósito do jogador.
            Giros grátis são rodadas em slots onde nenhum dinheiro é deduzido do saldo do jogador.
      </span>
    `,
    everyFreeSpins: (freeSpinCount: string) => `
    <span>
      Aqui no ${projectDomainName}
      <span style="color: #f2b62e">${freeSpinCount} Giros Grátis</span>
      no Depósito estão disponíveis para todos os jogadores permanentemente!
       Este bônus de Giros Grátis se aplica a cada depósito do jogador.
        Giros grátis são rodadas em slots onde nenhum dinheiro é deduzido do saldo do jogador.
    </span>
  `,
    firstDeposit: (depositBonus: string) => `
      <span>
        Aqui no ${projectDomainName}, <span style="color: #f2b62e"> um Bônus de primeiro Depósito de ${depositBonus}%</span>
         está disponível para todos os novos jogadores permanentemente!
          Este bônus se aplica apenas ao primeiro depósito do jogador e é igual a <span style="color: #f2b62e">${depositBonus}%</span> do valor depositado.
           Dinheiro de bônus são recompensas equivalentes a dinheiro real que o usuário recebe do cassino gratuitamente. Ao retirar fundos, o bônus não utilizado é cancelado!
      </span>
    `,
    everyDeposit: (depositBonus: string) => `
    <span>
          Aqui no ${projectDomainName} <span style="color: #f2b62e"> um Bônus de Depósito de ${depositBonus}%</span>
           está disponível para todos os jogadores permanentemente!
            Este bônus se aplica a cada depósito do jogador e é igual a <span style="color: #f2b62e">${depositBonus}%</span> do valor depositado.
             Dinheiro de bônus são recompensas equivalentes a dinheiro real que o usuário recebe do cassino gratuitamente.
              Ao retirar fundos, o bônus não utilizado é cancelado!
    </span>
  `,
    register: (freeSpinCount: string, wagerCoefficient: string) => `
  <span>
       Este bônus permite que você desfrute dos jogos de slot disponíveis em "jogos abertos" na sua área de promoções,
        onde cada jogada será deduzida dos <span style="color: #f2b62e">${freeSpinCount} GIROS GRÁTIS</span>!
        Qualquer saldo ganho durante essas jogadas pode ser convertido em saldo real, pronto para ser usado em jogos ou sacado.
        Contudo, é importante observar a regra de roll-over: o valor ganho nas rodadas grátis é multiplicado por <span style="color: #f2b62e">${wagerCoefficient}</span>,
         tornando-se sua meta a ser alcançada em até 7 dias. Para atingir essa conquista, basta efetuar um depósito e continuar jogando. A diversão está garantida!
</span>
`,
  },
  'fr-FR': {
    firstFreeSpins: (freeSpinCount: string) => `
      <span>
     Chez ${projectDomainName}, les <span style="color: #f2b62e">${freeSpinCount} tours gratuits</span> sans dépôt sont disponibles en permanence pour tous les joueurs ! Ce bonus de tours gratuits s'applique à chaque dépôt du joueur. Un tour gratuit est un tour de machine à sous où aucun argent n'est déduit du solde du joueur.
      </span>
    `,
    everyFreeSpins: (freeSpinCount: string) => `
      <span>
     Chez ${projectDomainName}, les <span style="color: #f2b62e">${freeSpinCount} tours gratuits</span> sans dépôt sont disponibles en permanence pour tous les joueurs ! Ce bonus de tours gratuits s'applique à chaque dépôt du joueur. Un tour gratuit est un tour de machine à sous où aucun argent n'est déduit du solde du joueur.
      </span>
    `,
    firstDeposit: (depositBonus: string) => `
     <span>
  Ici sur ${projectDomainName}, <span style="color: #f2b62e">un bonus de premier dépôt de ${depositBonus}%</span>
  est disponible en permanence pour tous les nouveaux joueurs.
  Ce bonus s'applique uniquement au premier dépôt du joueur et équivaut à <span style="color: #f2b62e">${depositBonus}%</span> du montant déposé.
  L'argent bonus sont des récompenses équivalentes à de l'argent réel que l'utilisateur reçoit du casino gratuitement. Lors du retrait de fonds, le bonus non utilisé est annulé.
</span>
    `,
    everyDeposit: (depositBonus: string) => `
     <span>
  Ici sur ${projectDomainName} <span style="color: #f2b62e">un Bonus de Dépôt de ${depositBonus}%</span>
  est disponible en permanence pour tous les joueurs !
  Ce bonus s'applique à chaque dépôt du joueur et équivaut à <span style="color: #f2b62e">${depositBonus}%</span> du montant déposé.
  L'argent bonus sont des récompenses équivalentes à de l'argent réel que l'utilisateur reçoit du casino gratuitement.
  Lors du retrait de fonds, le bonus non utilisé est annulé !
</span>
    `,
    register: (freeSpinCount: string, wagerCoefficient: string) => `
  <span>
    Ce bonus vous permet de profiter des jeux de machines à sous disponibles sous "jeux ouverts"
     dans votre zone de promotions, où chaque tour sera déduit des <span style="color: #f2b62e">${freeSpinCount} TOURS GRATUITS</span> !
      Tout solde gagné pendant ces jeux peut être converti en solde réel, prêt à être utilisé dans les jeux ou retiré.
       Cependant, il est important d'observer la règle de roll-over : le montant gagné dans les Tours Gratuits est multiplié par <span style="color: #f2b62e">${wagerCoefficient}</span>, en faisant votre objectif à atteindre dans les 7 jours.
        Pour atteindre cet accomplissement, il suffit de faire un dépôt et de continuer à jouer. Le plaisir est garanti !
</span>
`,
  },
  'en-US': {
    firstFreeSpins: (freeSpinCount: string) => `
      <span>
     At ${projectDomainName}, the <span style="color: #f2b62e">${freeSpinCount} no-deposit free spins</span> are permanently available to all players! This free spin bonus applies to each player's deposit. A free spin is a slot spin in which no money is deducted from the player's balance.
      </span>
    `,
    everyFreeSpins: (freeSpinCount: string) => `
      <span>
     At ${projectDomainName}, the <span style="color: #f2b62e">${freeSpinCount} no-deposit free spins</span> are permanently available to all players! This free spin bonus applies to each player's deposit. A free spin is a slot spin in which no money is deducted from the player's balance.
      </span>
    `,
    firstDeposit: (depositBonus: string) => `
    <span>
  Here at ${projectDomainName}, <span style="color: #f2b62e">a first deposit bonus of ${depositBonus}%</span>
  is permanently available for all new players!
  This bonus applies only to the player's first deposit and is equal to <span style="color: #f2b62e">${depositBonus}%</span> of the deposited amount.
  Bonus money is real-money equivalent rewards that the user receives from the casino for free. When withdrawing funds, any unused bonus is canceled!
</span>
    `,
    everyDeposit: (depositBonus: string) => `
    <span>
  Here at ${projectDomainName} <span style="color: #f2b62e">a Deposit Bonus of ${depositBonus}%</span>
  is permanently available for all players!
  This bonus applies to each deposit made by the player and is equal to <span style="color: #f2b62e">${depositBonus}%</span> of the deposited amount.
  Bonus money is real-money equivalent rewards that the user receives from the casino for free.
  When withdrawing funds, any unused bonus is canceled!
</span>
    `,
    register: (freeSpinCount: string, wagerCoefficient: string) => `
  <span>
    This bonus allows you to enjoy the slot games available under "open games"
     in your promotions area, where each spin will be deducted from the <span style="color: #f2b62e">${freeSpinCount} FREE SPINS</span>!
      Any balance earned during these plays can be converted into real balance, ready to be used in games or withdrawn.
       However, it is important to observe the roll-over rule: the amount won in the Free Spins is multiplied by <span style="color: #f2b62e">${wagerCoefficient}</span>, making it your goal to be achieved within 7 days.
        To achieve this achievement, simply make a deposit and continue playing. Fun is guaranteed!
</span>
`,
  },
}

export const getBonusCardFreeSpinsInfo = (
  lang: languagesType,
  freeSpins: number,
  promotioName: string,
  wagerCoefficient?: number,
) => {
  switch (promotioName) {
    case BonusName.firstDepositFreeSpins:
      return {
        __html: bonusCardInfo[lang].firstFreeSpins(String(freeSpins)),
      }
    case BonusName.everyDepositFreeSpins:
      return {
        __html: bonusCardInfo[lang].everyFreeSpins(String(freeSpins)),
      }
    case BonusName.register:
      return {
        __html: bonusCardInfo[lang].register(String(freeSpins), String(wagerCoefficient)),
      }
    default:
      return {
        __html: bonusCardInfo[lang].firstFreeSpins(String(freeSpins)),
      }
  }
}

export const getBonusCardFirstDepositInfo = (lang: languagesType, depositCoef: number, promotioName: string) => {
  switch (promotioName) {
    case BonusName.firstDepositBonus:
      return {
        __html: bonusCardInfo[lang].firstDeposit(String((depositCoef ?? 1) * 100)),
      }
    case BonusName.everyDepositBonus:
      return {
        __html: bonusCardInfo[lang].everyDeposit(String((depositCoef ?? 1) * 100)),
      }
    default:
      return {
        __html: bonusCardInfo[lang].firstDeposit(String((depositCoef ?? 1) * 100)),
      }
  }
}
